module.exports = __webpack_public_path__ + "img/zoomIn.d95e86d4.svg";